import { FormattedNumber } from 'react-intl';
import { roundToFixed } from 'utils/formatCurrency';
import { CURRENCY_USD, NUMBER_STYLE_CURRENCY } from './constants';
import {
  TotalBarSummaryBodyHighlight,
  TotalBarSummaryBodyStyle,
  TotalBarSummaryTitle
} from './styled';

export const TotalBarSummaryBody = ({
  highlighted,
  title,
  value
}: {
  highlighted?: boolean;
  title: React.JSX.Element;
  value: number | undefined;
}): React.JSX.Element => {
  const WrapperComponent = highlighted
    ? TotalBarSummaryBodyHighlight
    : TotalBarSummaryBodyStyle;
  const roundedValue = roundToFixed(value, 2);
  return (
    <WrapperComponent>
      <FormattedNumber
        value={roundedValue}
        /* eslint-disable-next-line react/style-prop-object */
        style={NUMBER_STYLE_CURRENCY}
        currency={CURRENCY_USD}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
      />
      <TotalBarSummaryTitle>{title}</TotalBarSummaryTitle>
    </WrapperComponent>
  );
};

TotalBarSummaryBody.defaultProps = {
  highlighted: false
};
